import React, { useMemo } from 'react';
import TableViewToggles, { type TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import { ChallengeDriverItem } from "../../../../types/gamification";
import Columns from './Columns';
import Row from './Row';
import { TableRowLoading } from '@components';
import classNames from "classnames";

interface CustomTableProps {
  viewType: TableViewTogglesViewType;
  trips: ChallengeDriverItem[];
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (key: string) => void;
  searchValue: string;
  onSearchChange: (v: string) => void;
  isLoading: boolean;
}

interface Column {
  key: string;
  label: string;
  sortable?: boolean;
  width?: string;
}

const COLUMNS = [
  { key: 'driverName', label: 'Motorista' },
  { key: 'challegeName', label: 'Desafio' },
  { key: 'routeName', label: 'Tipo' },
  { key: 'destination', label: 'Destino' },
  { key: 'tripDate', label: 'Data' },
  { key: 'vwcoin', label: 'Pontos' },
] as const;

const EmptyState = () => (
  <tr>
    <td colSpan={COLUMNS.length} className="text-center padding-y-24">
      Nenhum resultado
    </td>
  </tr>
);

const CustomTable: React.FC<CustomTableProps> = ({
  viewType,
  trips,
  sortBy,
  sortDir,
  onSort,
  isLoading,
}) => {
  const renderRows = useMemo(() => (
    trips.map((trip, idx) => <Row key={`${trip.driverId}-${idx}`} trip={trip} />)
  ), [trips]);
  const tableClassNames = classNames(
    "table",
    "table-layout-fixed",
    "table-column-overflow-hidden",
    "table-bordered",
    "table-sticky",
    "table-head-filled",
    viewType === TableViewToggles.VIEW_TYPE_SINGLE_CARD &&
    "table-cards table-single-card",
    viewType === TableViewToggles.VIEW_TYPE_MULTI_CARDS &&
    "table-cards table-multi-cards"
  );
  return (
    <div className="margin-top-16">
      <table className={tableClassNames}>
        <thead>
          <Columns
            columns={[...COLUMNS]}
            sortBy={sortBy}
            sortDir={sortDir}
            onSort={onSort}
          />
        </thead>
        <tbody>
          {isLoading ? (
            <TableRowLoading cols={6} rows={10} />
          ) : null}

          {!isLoading && trips.length === 0 ? <EmptyState /> : renderRows}

          {!isLoading &&
            trips.length > 0 &&
            viewType === TableViewToggles.VIEW_TYPE_MULTI_CARDS &&
            Array.from({ length: 9 }).map((_, index) => (
              <tr
                key={`card-placeholder-${index}`}
                className="table-card-placeholder"
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(CustomTable);